define((require) => {
    "use strict";

    const Preconditions   = require("shared/util/Preconditions");
    const valueFactories  = require("shared/data/groups/GroupsDescriptor").valueFactories;

    /**
     * A factory for creating concrete group values given the raw JSON attributes.
     *
     * @module GroupAssetFactory
     * @see GroupAssetCollection
     * @see GroupsDescriptor
     */
    return {

        /**
         * Creates a concrete/typed value from the raw JSON attributes.<p>
         *
         * Example (for a raw breakpoint type):
         *
         * <pre>
         * {
         *   "type": "Breakpoint",
         *   "reference": {
         *     "resourceId": "564c4a8be4b0f586d5e23361",
         *     "resourceType": "Experience"
         *   },
         *   "value": {
         *     "threshold": 0
         *   }
         * }
         * </pre>
         *
         * @param  {Object} attributes The raw JSON.
         * @return {*}                 The concrete value.
         */
        create(attributes) {
            const type = attributes.type;
            const value = attributes.value;

            Preconditions.checkState(valueFactories.has(type), `Invalid type: ${type}`);

            // Since 'value' is optional, bail out here if undefined...
            if (!value) {
                return null;
            }

            const factory = valueFactories.get(type);

            return factory(value);
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/groups/GroupValueFactory.js